import { useAuthStore } from '~/stores/auth'
import type { Pinia } from 'pinia'

/**
 * Use in route middleware (especially async) where `getActivePinia()` can be unset.
 * Docker dev + bind mounts often make that race more likely than local `npm run dev`.
 *
 * @see https://pinia.vuejs.org/core-concepts/outside-component-usage.html
 */
export function resolveAuthStore() {
  const nuxtApp = useNuxtApp()
  const pinia = nuxtApp.$pinia as Pinia | undefined
  if (!pinia) {
    return null
  }
  return useAuthStore(pinia)
}
